import React, { useRef, useState } from 'react';
import SectionOne from './HomeSections/SectionOne';
import SectionTwo from './HomeSections/SectionTwo';
import SectionThree from './HomeSections/SectionThree';
import SectionFour from './HomeSections/SectionFour';
import './HomeSections/home.css';

export default function Home() {
    const [journey, setJourney] = useState('assessment');
    const processHeading = useRef(null);
    function explore(id) {
        setJourney(id);
        const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        processHeading.current?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        processHeading.current?.focus({ preventScroll: true });
    }
    return <main className="bt-home">
        <SectionOne />
        <SectionTwo onExplore={explore} />
        <SectionThree />
        <SectionFour selected={journey} onSelect={setJourney} headingRef={processHeading} />
    </main>;
}
